<template>
  <v-card>
    <v-toolbar
      class="px-4"
      style="background: linear-gradient(60deg,#66bb6a,#43a047); color: white;"
    >
      <span
        style="font-size: 1.125rem; line-height: 1.4em; font-weight: 300; font-size: 18px;"
        >{{ [$t("commonWords.edit"), $t("commonWords.value")].join(" ") }}</span
      >
      <v-spacer></v-spacer>
      <md-button @click="$emit('cancel')" class="md-simple md-just-icon">
        <md-icon>close</md-icon>
      </md-button>
    </v-toolbar>
    <v-card-text class="pa-0">
      <md-card-content>
        <v-row
          no-gutters
          class="pa-0"
          style="margin-top: 20px; margin-bottom: 20px; width: 100%;"
        >
          <v-col cols="auto">
            <v-row no-gutters>
              <v-col cols="auto">
                <div class="textLabel colorDark" style="margin-top: 20px;">
                  {{$t('editEntityValue.value')}}
                </div>
                <md-field style="width: 300px; margin-right: 20px;">
                  <md-input
                    v-model="entityValue.value"
                    :placeholder="$t('editEntityValue.enterValueForExampleExtract')"
                  ></md-input>
                </md-field>
              </v-col>
              <v-col cols="auto" style="align-self: flex-end">
                <md-field>
                  <label for="type">{{$t('editEntityValue.type')}}</label>
                  <md-select v-model="entityValue.type" name="type" id="type">
                    <md-option value="synonyms">{{$t('editEntityValue.synonym')}}</md-option>
                    <md-option value="patterns">{{$t('editEntityValue.pattern')}}</md-option>
                  </md-select>
                </md-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto">
            <v-row no-gutters>
              <v-col cols="12">
                <div class="textLabel colorDark" style="margin-top: 20px;">
                  {{ entityValue.type == "synonyms" ? "Sinônimo" : "Padrão" }}
                </div>
              </v-col>
              <template v-if='entityValue.type == "synonyms"'>
                <v-col
                  v-for="n in entityValue.synonyms.length"
                  :key="n"
                  cols="auto"
                >
                  <md-field
                    style="width: 300px; margin-right: 20px; display: inline-block;"
                  >
                    <md-input
                      v-model="entityValue.synonyms[n - 1]"
                      :placeholder="
                        entityValue.type == 'synonyms'
                          ? 'Por exemplo Resumo'
                          : 'Por exemplo: (\\d{3})'
                      "
                    ></md-input>
                  </md-field>
                  <span @click="removeContent(n - 1)" style="margin-right: 20px;">
                    <md-icon style="cursor: pointer;">horizontal_rule</md-icon>
                  </span>
                </v-col>
              </template>
              <template v-else>
                <v-col
                  v-for="n in entityValue.patterns.length"
                  :key="n"
                  cols="auto"
                >
                  <md-field
                    style="width: 300px; margin-right: 20px; display: inline-block;"
                  >
                    <md-input
                      v-model="entityValue.patterns[n - 1]"
                      :placeholder="
                        entityValue.type == 'synonyms'
                          ? this.$t('editEntityValue.forExampleSummary')
                          : this.$t('editEntityValue.forExample')
                      "
                    ></md-input>
                  </md-field>
                  <span @click="removeContent(n - 1)" style="margin-right: 20px;">
                    <md-icon style="cursor: pointer;">horizontal_rule</md-icon>
                  </span>
                </v-col>
              </template>

              <v-col cols="auto" style="align-self: flex-end;">
                <md-field
                  style="width: 300px; margin-right: 20px; display: inline-block;"
                >
                  <md-input
                    @blur.passive="addContent()"
                    @keyup.enter="addContent()"
                    v-model="attAdd"
                    :placeholder="
                      entityValue.type == 'synonyms'
                        ? this.$t('editEntityValue.forExampleSummary')
                        : this.$t('editEntityValue.forExample')
                    "
                  ></md-input>
                </md-field>
                <v-btn
                  x-small
                  fab
                  @click="addContent()"
                  elevation="0"
                  style="background-color: white;"
                >
                  <md-icon style="cursor: pointer; color: blue;">add</md-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </md-card-content>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <md-button
        @click="$emit('cancel')"
        class="md-danger"
        style="margin-right: 8px;"
      >
        <span>{{ $t("commonWords.cancel") }}</span>
      </md-button>
      <md-button @click="save" class="md-success">
        <span>{{ $t("commonWords.save") }}</span>
      </md-button>
    </v-card-actions>
  </v-card>
</template>

<script>
import clonedeep from 'lodash.clonedeep'
import Swal from 'sweetalert2'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    attAdd: '',
    entityValue: {}
  }),
  created () {
    this.entityValue = clonedeep(this.value)
  },
  methods: {
    addContent () {
      if (this.attAdd !== '') {
        const attValue = this.entityValue[this.entityValue.type].some(currentAtt => this.attAdd.toUpperCase() === currentAtt.toUpperCase())
        if (attValue) {
          Swal.fire({
            icon: 'error',
            title: `Entity ${this.entityValue.type} error`,
            text: this.$t('editEntityValue.thisSynonymPatternAlreadyRegistered'),
            showConfirmButton: true
          })
          return
        }

        this.entityValue[this.entityValue.type].push(this.attAdd)
        this.attAdd = ''
      }
    },
    removeContent (index) {
      if (this.entityValue.type === 'synonyms') {
        this.entityValue.synonyms.splice(index, 1)
      } else {
        this.entityValue.patterns.splice(index, 1)
      }
    },
    save () {
      this.$emit('input', this.entityValue)
      this.$emit('cancel')
    }
  }
}
</script>
